export default __webpack_public_path__ + "static/media/pear.bfd2cd8f.svg";